import '@pixi/events';
import { Container, Sprite, Stage } from '@pixi/react';
import FemaleBase from "@Resources/app/kit-editor/render_female_base.webp";
import FemalePrimary from "@Resources/app/kit-editor/render_female_primary.webp";
import FemaleSecondary from "@Resources/app/kit-editor/render_female_secondary.webp";
import FemaleTertiary from "@Resources/app/kit-editor/render_female_tertiary.webp";
import MaleBase from "@Resources/app/kit-editor/render_male_base.webp";
import MalePrimary from "@Resources/app/kit-editor/render_male_primary.webp";
import MaleSecondary from "@Resources/app/kit-editor/render_male_secondary.webp";
import MaleTertiary from "@Resources/app/kit-editor/render_male_tertiary.webp";

interface IKitPixyComponent {
    gender: string;
    width?: number;
    height: number;
    isPlayer?: boolean;
    playerPrimary?: string;
    playerSecondary?: string;
    playerTertiary?: string;
    goalkeeperPrimary?: string;
    goalkeeperSecondary?: string;
    goalkeeperTertiary?: string;
}

const KitPixyComponent = ({gender, width, height, isPlayer, 
    playerPrimary, playerSecondary, playerTertiary, 
    goalkeeperPrimary, goalkeeperSecondary, goalkeeperTertiary}: IKitPixyComponent) => {

    return (
    <Stage width={width || 300} height={height} options={{backgroundAlpha: 0}}>
            <Container position={0} scale={1}>
              <Sprite
                image={gender === 'FEMALE' ? FemaleBase : MaleBase}
                width={width || 300}
                height={height}
              />
              <Sprite
                image={gender === 'FEMALE' ? FemalePrimary : MalePrimary}
                width={width || 300}
                height={height}
                tint={isPlayer ? playerPrimary : goalkeeperPrimary}
              />
              <Sprite
                image={gender === 'FEMALE' ? FemaleSecondary : MaleSecondary}
                width={width || 300}
                height={height}
                tint={isPlayer ? playerSecondary : goalkeeperSecondary}
              />
              <Sprite
                image={gender === 'FEMALE' ? FemaleTertiary : MaleTertiary}
                width={width || 300}
                height={height}
                tint={isPlayer ? playerTertiary : goalkeeperTertiary}
              />
            </Container>
        </Stage>
    );
};

export default KitPixyComponent;